
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  props: {
    facetData: {
      type: Object,
      default: () => ({}),
    },
    filterData: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    selectedCheckbox: '',
    isFocused: false,
  }),
  computed: {
    ...mapGetters({
      vxSearchFilters: 'search/getSearchFilters',
    }),
    filterValue() {
      if (this.facetData.field === 'ss_final_price') {
        return `filter.${this.facetData.field}.low=${this.filterData.low}&filter.${this.facetData.field}.high=${this.filterData.high}`
      } else {
        return `filter.${this.facetData.field}=${this.filterData.value}`
      }
    },
    searchFilters: {
      get() {
        return this.vxSearchFilters
      },
      set(value) {
        this.vxSetSearchFilters(value)
        this.vxQuerySearchspring()
      },
    },
    isSelected() {
      return this.vxSearchFilters.includes(this.filterValue)
    },
  },
  methods: {
    ...mapActions({
      vxQuerySearchspring: 'search/querySearchspring',
    }),
    ...mapMutations({
      vxSetSearchFilters: 'search/setSearchFilters',
    }),
  },
}
